import { render } from "./TeamsPage.vue?vue&type=template&id=a7946db8&ts=true"
import script from "./TeamsPage.vue?vue&type=script&lang=ts"
export * from "./TeamsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__